import Component from '@glimmer/component'
import { tracked } from '@glimmer/tracking'
import { guidFor } from '@ember/object/internals'
import { on } from '@ember/modifier'
import { formatDate, t } from 'ember-intl'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon.gts'
import { getStickerFullPath } from 'teacher-ui-client/components/writing-legends/sticker-selector.gts'
import { MAX_MARK } from 'teacher-ui-client/components/writing-legends/teacher-feedback-form.gts'

interface Signature {
  Element: HTMLDivElement
  Blocks: {
    default: []
  }
  Args: {
    date: number
    title: string
    mark: number
    sticker: Nullable<string>
    disabled?: boolean
  }
}

export class TeacherFeedbackCard extends Component<Signature> {
  @tracked isOpen = true

  get id() {
    return guidFor(this)
  }

  toggle = () => {
    this.isOpen = !this.isOpen
  }

  get stickerFullPath() {
    if (!this.args.sticker) {
      return null
    }
    return getStickerFullPath(this.args.sticker)
  }

  <template>
    <div
      data-test-teacher-feedback-card
      class="flex flex-col rounded-3xl border-2 border-[#fee7c7] bg-[#fef3e3]"
      ...attributes
    >
      <button
        type="button"
        data-test-toggle-button
        class="relative flex rounded-3xl bg-[#fee7c7] p-3"
        aria-expanded={{if this.isOpen "true" "false"}}
        aria-controls="{{this.id}}-content"
        {{on "click" this.toggle}}
        disabled={{@disabled}}
      >
        <div class="flex w-full">
          <div class="basis-1/4 text-left">{{formatDate
              @date
              locale="en-AU"
              day="numeric"
              month="short"
              year="numeric"
            }}</div>
          <div class="basis-1/2 font-bold">{{@title}}</div>
          <div class="basis-1/4 text-right">
            {{#if this.isOpen}}
              <PhosphorIcon @icon="phosphor-caret-down" />
            {{else}}
              <PhosphorIcon @icon="phosphor-caret-up" />
            {{/if}}
          </div>
        </div>

      </button>
      {{#if this.isOpen}}
        <div id="{{this.id}}-content" class="flex w-full justify-between p-4">
          <div class="flex basis-3/4 flex-col justify-between">
            <div>{{yield}}</div>
            <div class="mt-8">{{t "pages.recentWriting.viewWriting.feedbacks.mark"}}:
              <strong>{{@mark}}/{{MAX_MARK}}</strong></div>
          </div>

          {{#if this.stickerFullPath}}
            <div class="flex basis-1/4 justify-end">
              <img
                src={{this.stickerFullPath}}
                alt={{t "pages.recentWriting.viewWriting.feedbacks.celebrationSticker"}}
                width="117"
                height="150"
              />
            </div>
          {{/if}}
        </div>
      {{/if}}
    </div>
  </template>
}

export default TeacherFeedbackCard
